"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED_DEFAULT = void 0;
exports.specialDocumentRequirementsEnabled = specialDocumentRequirementsEnabled;
/**
 * Central soft-disable for special DocumentRequirement semantics.
 * Default DISABLED. Override with SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED=true.
 * No DB flag / admin settings screen.
 */
exports.SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED_DEFAULT = false;
function readDefaultEnv() {
    const proc = globalThis.process;
    return proc?.env;
}
function specialDocumentRequirementsEnabled(env = readDefaultEnv()) {
    const raw = env?.SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED ?? env?.VITE_SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED;
    if (raw === undefined || String(raw).trim() === '') {
        return exports.SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED_DEFAULT;
    }
    const normalized = String(raw).trim().toLowerCase();
    if (normalized === '1' || normalized === 'true' || normalized === 'yes') {
        return true;
    }
    if (normalized === '0' || normalized === 'false' || normalized === 'no') {
        return false;
    }
    return exports.SPECIAL_DOCUMENT_REQUIREMENTS_ENABLED_DEFAULT;
}
//# sourceMappingURL=special-document-requirements.js.map